import React, { useEffect, useState } from 'react'

import { AgGridReact } from 'ag-grid-react'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import './styles.css'
import { TableLineDisable } from '../../../../components/TableLineDisable/TableLineDisable'
import { api } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'

export const EibList = ({ filter }) => {
  const [eibList, seteibList] = useState([])
  const [, setRows] = useState()

  useEffect(() => {
    if (filter.safra_id) {
      loadEibList(filter)
    }
  }, [filter])

  async function loadEibList(filter) {
    const response = await api.getEibDashboardGrid(filter)
    seteibList(response)
  }

  const onGridReady = (params) => {
    setRows(params.api.getDisplayedRowCount())
  }

  function getColumnsToCustomersTable() {
    const columns = [
      {
        headerName: getMessage('categoryAction'),
        field: 'acao',
        filter: 'agTextColumnFilter',
        width: 100,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('customer'),
        field: 'agricultor',
        filter: 'agTextColumnFilter',
        width: 200,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('CPFCNPJ'),
        field: 'document_number',
        filter: 'agTextColumnFilter',
        width: 60,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />,
        cellStyle: {
          height: '100%',
          display: 'flex ',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }
      },
      {
        headerName: getMessage('CPFCNPJIMPULSO'),
        field: 'cpf',
        filter: 'agTextColumnFilter',
        width: 60,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />,
        cellStyle: {
          height: '100%',
          display: 'flex ',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }
      },
      {
        headerName: getMessage('farm'),
        field: 'fazenda',
        filter: 'agTextColumnFilter',
        width: 150,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('regionId'),
        field: 'regional',
        filter: 'agTextColumnFilter',
        width: 130,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('districtId'),
        field: 'distrito',
        filter: 'agTextColumnFilter',
        width: 130,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('categoryActionClassification'),
        field: 'classificacao',
        filter: 'agTextColumnFilter',
        width: 60,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />,
        cellStyle: {
          height: '100%',
          display: 'flex ',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }
      },
      {
        headerName: getMessage('action'),
        field: 'visita',
        filter: 'agTextColumnFilter',
        width: 150,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('statusLoad'),
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 60,
        cellRenderer: ({ value, data }) => (
          <TableLineDisable item={value == 'ABERTA' ? 'EM ABERTO' : value.toUpperCase()} line={data} />
        ),
        cellStyle: ({ data }) => {
          if (data.status.toUpperCase() === 'EXECUTADA') {
            return {
              backgroundColor: '#c9fdaf',
              height: '70%',
              width: 115,
              marginTop: 3,
              display: 'flex ',
              justifyContent: 'center',
              alignItems: 'center ',
              textAlign: 'center '
            }
          }

          if (data.status.toUpperCase() === 'ABERTA') {
            return {
              backgroundColor: '#D6DAE0',
              height: '70%',
              width: 115,
              marginTop: 3,
              display: 'flex ',
              justifyContent: 'center',
              alignItems: 'center ',
              textAlign: 'center '
            }
          }

          if (data.status.toUpperCase() === 'CANCELADA') {
            return {
              backgroundColor: '#F7BCC8',
              height: '70%',
              width: 115,
              display: 'flex ',
              justifyContent: 'center',
              alignItems: 'center ',
              textAlign: 'center '
            }
          }
        }
      },
      {
        headerName: 'Status do planejamento',
        field: 'planejada',
        filter: 'agTextColumnFilter',
        width: 150,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value.toUpperCase()} line={data} />
      }
    ]
    return columns
  }

  const defaultColDef = {
    sortable: true,
    resizable: true,
    minWidth: 120,
    width: 150,
    enableRowGroup: false,
    enablePivot: false,
    enableValue: true,
    floatingFilter: true,
    cellStyle: {
      height: '100%',
      display: 'flex '
    }
  }

  return (
    <div style={{ width: '100%', height: '70vh' }}>
      <div
        style={{
          height: '100%',
          width: '100%',
          marginTop: 0
        }}
        className="ag-theme-alpine"
      >
        <AgGridReact
          // ref={gridRef}
          columnDefs={getColumnsToCustomersTable()}
          defaultColDef={defaultColDef}
          rowData={eibList}
          onGridReady={onGridReady}
          rowSelection={'multiple'}
          rowGroupPanelShow={'always'}
          pivotPanelShow={'always'}
        />
      </div>
    </div>
  )
}
